import { CLIENT_CARD_PROPERTY_KEYS } from 'src/graphql/entities/side-panel-personalization/model/card-keys';
import type { SidePanelPropertyDescriptor } from 'src/graphql/entities/side-panel-personalization/model/descriptors';

// visibility catalog for the existing client cards (ClientCard) — the fields
// render there, so no Row components here
export const CLIENT_SECTION_PROPERTIES: SidePanelPropertyDescriptor[] = [
  {
    key: CLIENT_CARD_PROPERTY_KEYS.email,
    label: 'Email',
    defaultVisible: true,
    icon: 'email',
  },
  {
    key: CLIENT_CARD_PROPERTY_KEYS.phone,
    label: 'Phone',
    defaultVisible: true,
    icon: 'phone_iphone',
  },
  {
    key: CLIENT_CARD_PROPERTY_KEYS.labels,
    label: 'Labels',
    defaultVisible: true,
    icon: 'sell',
  },
  {
    key: CLIENT_CARD_PROPERTY_KEYS.note,
    label: 'Note',
    defaultVisible: true,
    icon: 'sticky_note_2',
  },
];
